import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { cn } from "../../lib/utils.ts";

type BadgeVariant = "default" | "success" | "warning" | "error" | "info";

interface BadgeProps extends ComponentPropsWithoutRef<"span"> {
  variant?: BadgeVariant;
  children: ReactNode;
}

const variantStyles: Record<BadgeVariant, string> = {
  default: "bg-slate-100 text-slate-700",
  success: "border border-green-200 bg-green-50 text-success",
  warning: "border border-amber-200 bg-amber-50 text-amber-700",
  error: "border border-red-200 bg-red-50 text-error",
  info: "border border-brand-200 bg-brand-50 text-brand-700",
};

export function Badge({
  variant = "default",
  children,
  className,
  ...rest
}: BadgeProps) {
  return (
    <span
      {...rest}
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium",
        variantStyles[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
